import { useEffect } from 'react';
import { Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import PrivateRoute from './components/common/private-route' 
import { history } from './redux/modules/auth';
import {isMobile} from "./redux/modules/mobile"
import useDetectKeyboardOpen from "use-detect-keyboard-open";
import useDeviceDetect from "./hooks/use-touch";
import Dashboard from './components/Dashboard';
import Regist from './components/Regist'; 
import RegistSuccess from './components/RegistSuccess'; 
import Login from './components/Login'; 
import Verification from './components/Verification';
import Docs from './components/Docs';
import News from './components/News';
import NewsItem from './components/News/newsItem';
import DocsProject from './components/Docs/project';
import DocsType from './components/Docs/type';
import DocsFiles from './components/Docs/typein';
import Contacts from './components/Contacts';
import CheckClient from './components/CheckClient';
import Agents from './components/Agents';
import DeleteAgent from './components/DeleteAgent';
import AddBlacklist from './components/AddBlacklist';
import DeleteBlacklist from './components/DeleteBlacklist';
import ChangeAccess from './components/ChangeAccess';
import Profile from './components/Profile';
import Clients from './components/Clients';
import Bookings from './components/Bookings';
import Meetings from './components/Meetings';
import CancelMeeting from './components/CancelMeeting';
import CancelBrokerTour from './components/CancelBrokerTour';
import Deals from './components/Deals';
import BrokerTours from './components/BrokerTours';
import RegistMeeting from './components/RegistMeeting';
import RegistBrokerTour from './components/RegistBrokerTour';
import EditMeeting from './components/EditMeeting';
import EditBrokerTour from './components/EditBrokerTour';
import Realty from './components/Realty';
import RealtyDetail from './components/Realty/realtyDetail';

function App() {
  const dispatch = useDispatch();
  const mobile = useSelector(state => state.mobile);
  const isKeyboardOpen = useDetectKeyboardOpen();
  const isTouchDevice = useDeviceDetect();
  let vh = window.innerHeight * 0.01;
  let innerHeight = require('ios-inner-height');

  history.navigate = useNavigate();
  history.location = useLocation();

  const { pathname } = useLocation();

  useEffect(() => {

    let height = isTouchDevice ? (innerHeight()) : window.innerHeight

    //alert('размер ' + height)
    //console.log(height)
    //console.log(isTouchDevice)

    //document.getElementsByClassName("page")[0].style.minHeight = height  + "px"
    //document.getElementsByClassName("page")[0].style.height = height  + "px"

    if(isKeyboardOpen) {
      document.getElementsByTagName("body")[0].className = 'no-touchmove'
    } else {
      document.getElementsByTagName("body")[0].className = ''
    }

    const resize = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);

      const mob = window.innerWidth <= 1000;
      dispatch(isMobile(mob));
    }

    resize()
    window.addEventListener('load', resize);
    window.addEventListener('orientationchange', resize);
    window.addEventListener('resize', resize);

    return () => {
      window.removeEventListener('load', resize);
      window.removeEventListener('orientationchange', resize);
      window.removeEventListener('resize', resize);
    };

  },[])


  useEffect(() => {
    window?.scrollTo(0, 0);
  }, [pathname]);


  return (
    <div className="App">
	    <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/verify" element={<Verification />} />
        <Route path="/regist" element={<Regist />} />
        <Route path="/regist-success" element={<RegistSuccess />} />
        <Route index element={<PrivateRoute><Dashboard /></PrivateRoute>} />      
        <Route path="/profile" title="Профиль" element={<PrivateRoute><Profile /></PrivateRoute>} />      
        <Route path="/docs" title="Документы" element={<PrivateRoute><Docs /></PrivateRoute>} /> 
        <Route path="/docs/:detail" title="Документы" element={<PrivateRoute><DocsProject /></PrivateRoute>} />  
        <Route path="/docs/:detail/:type" title="Документы" element={<PrivateRoute><DocsType /></PrivateRoute>} />   
        <Route path="/docs/:detail/:type/:files" title="Документы" element={<PrivateRoute><DocsFiles /></PrivateRoute>} />   
        <Route path="/news" title="Новости" element={<PrivateRoute><News /></PrivateRoute>} />            
        <Route path="/news/:detail" title="Новости" element={<PrivateRoute><NewsItem /></PrivateRoute>} />          
        <Route path="/contacts" title="Контакты" element={<PrivateRoute><Contacts /></PrivateRoute>} />      
        <Route path="/check-client" title="Проверить клиента" element={<PrivateRoute><CheckClient /></PrivateRoute>} />           
        <Route path="/agents-list" title="Пользователи" element={<PrivateRoute><Agents /></PrivateRoute>} />        
        <Route path="/delete-agent" title="Удаление пользователя" element={<PrivateRoute><DeleteAgent /></PrivateRoute>} />      
        <Route path="/add-blacklist" title="Перенос в черный список" element={<PrivateRoute><AddBlacklist /></PrivateRoute>} />      
        <Route path="/delete-blacklist" title="Удаление из черного списка" element={<PrivateRoute><DeleteBlacklist /></PrivateRoute>} />      
        <Route path="/change-access" title="Изменение прав доступа" element={<PrivateRoute><ChangeAccess /></PrivateRoute>} />      
        <Route path="/clients" title="Клиенты" element={<PrivateRoute><Clients /></PrivateRoute>} />      
        <Route path="/bookings" title="Брони" element={<PrivateRoute><Bookings /></PrivateRoute>} />      
        <Route path="/meetings" title="Встречи" element={<PrivateRoute><Meetings /></PrivateRoute>} />       
        <Route path="/cancel-meeting" title="Отменить встречу" element={<PrivateRoute><CancelMeeting /></PrivateRoute>} />    
        <Route path="/cancel-broker-tour" title="Отменить брокер-тур" element={<PrivateRoute><CancelBrokerTour /></PrivateRoute>} />    
        <Route path="/deals" title="Сделки" element={<PrivateRoute><Deals /></PrivateRoute>} /> 
        <Route path="/broker-tours" title="Брокер-туры" element={<PrivateRoute><BrokerTours /></PrivateRoute>} /> 
        <Route path="/regist-meeting" title="Записаться на встречу" element={<PrivateRoute><RegistMeeting /></PrivateRoute>} />      
        <Route path="/regist-broker-tour" title="Записаться на брокер-тур" element={<PrivateRoute><RegistBrokerTour /></PrivateRoute>} />       
        <Route path="/edit-meeting" title="Редактировать встречу" element={<PrivateRoute><EditMeeting /></PrivateRoute>} />      
        <Route path="/edit-broker-tour" title="Редактировать брокер-тур" element={<PrivateRoute><EditBrokerTour /></PrivateRoute>} />      
        <Route path="/realty" title="Выбор недвижимости" element={<PrivateRoute><Realty /></PrivateRoute>} />      
        <Route path="/realty/:detail" title="Выбор недвижимости" element={<PrivateRoute><RealtyDetail /></PrivateRoute>} />       
      </Routes>
    </div>
  );
}

export default App;
